import Vue from "vue";
import Vuex from "vuex";
import login from "./store/login";

Vue.use(Vuex);

// STATE
const state = {
  date: new Date(),
  isAddressValid: false,
  datasources: {
    pickupLocation: {},
    reasons: {},
    aisAddress: {},
  },
  appconfig: {
    urlApi: process.env.VUE_APP_API_BASE_URL || "/api",
    urlAis: process.env.VUE_APP_AIS_HOST,
    aisGatekeeper: process.env.VUE_APP_GATEKEEPERKEY,
  },
};

// MUTATIONS
const mutations = {
  SET_DATE: (state, newDate) => {
    state.date = newDate;
  },
  SET_AISADDRESS: (state, newAddress) => {
    state.datasources.aisAddress = newAddress;
  },
  SET_REASONS: (state, newReasons) => {
    state.datasources.reasons = newReasons;
  },
  SET_PICKUPLOCATIONS: (state, newPickupLocation) => {
    state.datasources.pickupLocation = newPickupLocation;
  },
  SET_ISADDRESSVALID: (state, newValidAddres) => {
    state.isAddressValid = newValidAddres;
  },
};

// ACTIONS
const actions = {
  setDate: ({ commit, state }, newDate) => {
    commit("SET_DATE", newDate);
    return state.date;
  },
  setAisAddress: ({ commit, state }, newAddress) => {
    commit("SET_AISADDRESS", newAddress);
    return state.datasources.aisAddress;
  },
  setReasons: ({ commit, state }, newReasons) => {
    commit("SET_REASONS", newReasons);
    return state.datasources.reasons;
  },
  setPickupLocation: ({ commit, state }, newPickupLocation) => {
    commit("SET_PICKUPLOCATIONS", newPickupLocation);
    return state.datasources.pickupLocation;
  },
  setIsAddressValid: ({ commit, state }, newValidAddres) => {
    commit("SET_ISADDRESSVALID", newValidAddres);
    return state.isAddressValid;
  },
};

//GETTERS
const getters = {
  date: (state) => {
    return state.date;
  },
  aisAddress: (state) => {
    return state.datasources.aisAddress;
  },
  reasons: (state) => {
    return state.datasources.reasons;
  },
  pickupLocation: (state) => {
    return state.datasources.pickupLocation;
  },
  isAddressValid: (state) => {
    return state.isAddressValid;
  },
};

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: {
    login,
  },
});
